/* ============================================================
   CHRISTIANNE ROUSSEAU — Theme JS
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  // --- Search Toggle ---
  const searchToggles = document.querySelectorAll('[data-search-toggle]');
  const searchBar = document.getElementById('search-bar');

  searchToggles.forEach(btn => {
    btn.addEventListener('click', () => {
      const isOpen = searchBar.classList.toggle('is-open');
      searchBar.setAttribute('aria-hidden', !isOpen);
      if (isOpen) {
        const input = searchBar.querySelector('.search-input');
        if (input) setTimeout(() => input.focus(), 300);
      }
    });
  });

  // Close search on Escape
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && searchBar.classList.contains('is-open')) {
      searchBar.classList.remove('is-open');
      searchBar.setAttribute('aria-hidden', 'true');
    }
  });

  // --- Mobile Menu ---
  const mobileToggle = document.querySelector('[data-mobile-menu]');
  const mobileNav = document.getElementById('mobile-nav');

  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', () => {
      const isOpen = mobileNav.classList.toggle('is-open');
      mobileNav.setAttribute('aria-hidden', !isOpen);
      mobileToggle.setAttribute('aria-expanded', isOpen);
    });
  }

  // --- Product Gallery ---
  const galleryThumbs = document.querySelectorAll('.gallery-thumb');
  const mainImage = document.getElementById('gallery-main-image');

  galleryThumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      galleryThumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImage) {
        const newSrc = thumb.dataset.src;
        mainImage.style.opacity = '0';
        setTimeout(() => {
          mainImage.src = newSrc;
          mainImage.style.opacity = '1';
        }, 200);
        mainImage.style.transition = 'opacity 200ms ease';
      }
    });
  });

  // --- Sort Select ---
  const sortSelect = document.querySelector('[data-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  // --- Wishlist ---
  const wishlistBtns = document.querySelectorAll('[data-wishlist]');
  const WISHLIST_KEY = 'cr_wishlist';

  const getWishlist = () => {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
    } catch {
      return [];
    }
  };

  const saveWishlist = (list) => {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
  };

  const updateWishlistUI = () => {
    const list = getWishlist();
    wishlistBtns.forEach(btn => {
      const id = parseInt(btn.dataset.wishlist);
      btn.classList.toggle('is-saved', list.includes(id));
    });
  };

  wishlistBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const id = parseInt(btn.dataset.wishlist);
      let list = getWishlist();
      if (list.includes(id)) {
        list = list.filter(i => i !== id);
      } else {
        list.push(id);
      }
      saveWishlist(list);
      updateWishlistUI();
    });
  });

  updateWishlistUI();

  // --- Cart Quantity Update ---
  const qtyBtns = document.querySelectorAll('.qty-btn');

  qtyBtns.forEach(btn => {
    btn.addEventListener('click', async () => {
      const key = btn.dataset.key;
      const change = parseInt(btn.dataset.change);
      const valueEl = btn.closest('.cart-item__quantity').querySelector('.qty-value');
      const currentQty = parseInt(valueEl.textContent);
      const newQty = Math.max(0, currentQty + change);

      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: newQty })
        });
        const cart = await res.json();

        if (newQty === 0) {
          btn.closest('.cart-item').remove();
        } else {
          valueEl.textContent = newQty;
        }

        // Update cart count in header
        const cartCountEl = document.querySelector('.cart-count');
        if (cartCountEl) {
          cartCountEl.textContent = cart.item_count;
          cartCountEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
        }

        // Reload to update prices
        if (newQty === 0) window.location.reload();

      } catch (err) {
        console.error('Cart update failed:', err);
      }
    });
  });

  // --- Cart Remove ---
  const removeBtns = document.querySelectorAll('.cart-item__remove');

  removeBtns.forEach(btn => {
    btn.addEventListener('click', async () => {
      const key = btn.dataset.key;
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        });
        btn.closest('.cart-item').remove();
        window.location.reload();
      } catch (err) {
        console.error('Remove failed:', err);
      }
    });
  });

  // --- Variant Selector ---
  const variantSelects = document.querySelectorAll('.option-select');
  const addToCartBtn = document.querySelector('.product-form [name="add"]');

  if (variantSelects.length > 0 && addToCartBtn) {
    // Build variant map from Shopify product JSON
    const productJSON = document.getElementById('product-json');
    if (productJSON) {
      try {
        const product = JSON.parse(productJSON.textContent);
        const variants = product.variants;

        variantSelects.forEach(select => {
          select.addEventListener('change', () => {
            const selectedOptions = Array.from(variantSelects).map(s => s.value);
            const match = variants.find(v =>
              v.options.every((opt, i) => opt === selectedOptions[i])
            );

            if (match) {
              const hiddenInput = document.querySelector('[name="id"]');
              if (hiddenInput) hiddenInput.value = match.id;

              const priceEl = document.querySelector('.product-price');
              if (priceEl && match.price) {
                priceEl.textContent = formatMoney(match.price);
              }

              if (!match.available) {
                addToCartBtn.disabled = true;
                addToCartBtn.textContent = 'Sold Out';
              } else {
                addToCartBtn.disabled = false;
                addToCartBtn.textContent = `Add to Cart — ${formatMoney(match.price)}`;
              }
            }
          });
        });
      } catch (e) {
        // No product JSON
      }
    }
  }

  function formatMoney(cents) {
    return '€' + (cents / 100).toLocaleString('nl-NL', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  // --- Sticky scroll: collapse header on scroll ---
  const siteHeader = document.querySelector('.site-header');
  if (siteHeader) {
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          siteHeader.classList.toggle('scrolled', window.scrollY > 60);
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

});
